module.exports = __webpack_public_path__ + "static/media/logo-calvados-departement.603a7d10.jpg";